export const Types = {
  // Lista Atividades
  GET_LIST_REQUEST: 'attachment-by-module/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'attachment-by-module/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'attachment-by-module/GET_LIST_FAILURE',

  // reseta Lista de Atividades
  RESET_LIST: 'attachment-by-module/RESET_LIST',
};

export const initialState = {
  // Lista de Atividades
  attachmentsByModuleList: [],
  attachmentsByModuleListLoading: false,
  attachmentsByModuleListError: null,
  attachmentsByModuleListTotal: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // Lista de Atividades
    case Types.GET_LIST_REQUEST:
      return { ...state, attachmentsByModuleListLoading: true };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        attachmentsByModuleList: action.payload.data,
        attachmentsByModuleListLoading: false,
        attachmentsByModuleListError: null,
        attachmentsByModuleListTotal: action.payload.total,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        attachmentsByModuleListLoading: false,
        attachmentsByModuleListError: action.payload,
      };
    case Types.RESET_LIST:
      return {
        ...state,
        attachmentsByModuleList: [],
        attachmentsByModuleListLoading: false,
        attachmentsByModuleListError: null,
        attachmentsByModuleListTotal: 0,
      };
    default:
      return state;
  }
};

export const Creators = {
  // Busca lista de Atividade
  getAttachmentsByModuleListRequest: (data) => ({
    type: Types.GET_LIST_REQUEST,
    payload: data,
  }),
  getAttachmentsByModuleListSuccess: ({ data, total }) => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { data, total },
  }),
  getAttachmentsByModuleListFailure: error => ({
    type: Types.GET_LIST_FAILURE,
    payload: error,
  }),
  resetList: () => ({
    type: Types.RESET_LIST,
  }),
};
